import React from 'react';
import {Route, Switch, withRouter} from "react-router-dom";


import TagModerationVerifications from "./Verifications/Verifications";
import TagModerationQualifications from "./Qualifications/Qualifications";
import ErrorUnauthorized from "../ErrorUnauthorized";
import {Can} from "../../../ability-context";
import TagModerationQualificationPhoto from "./QualificationPhoto/QualificationPhoto";
import TagModerationQualificationVideo from "./QualificationVideo/QualificationVideo";
import TagModerationVerificationCategory from "./VerificationsPhoto/VerificationsCategory";
import TagModerationVerificationVideoCategory from "./VerificationsVideo/VerificationsCategory";
import AskForAuthorization from "./AskForAuthorization/AskForAuthorization";

const RedirecToQualificationPage = (props) => {
    props.history.push(`/tag-moderations/qualifications`);
    return null;
}

const RedirecToRightQualificationPage = (props) => {
    props.history.push(`/tag-moderations`);
    return null;
}

function Qualifications(props) {
    return <Can action="qualification" subject="TagModeration" passThrough>
        {can => !can ? <RedirecToRightQualificationPage {...props}/> : <TagModerationQualifications {...props}/>}
    </Can>;
}

function QualificationPhoto(props) {
    return <Can action="qualification" subject="TagModeration" passThrough>
        {can => !can ? <RedirecToRightQualificationPage {...props}/> : <TagModerationQualificationPhoto {...props}/>}
    </Can>;
}
function QualificationVideo(props) {
    return <Can action="qualification" subject="TagModeration" passThrough>
        {can => !can ? <RedirecToRightQualificationPage {...props}/> : <TagModerationQualificationVideo {...props}/>}
    </Can>;
}

function Verifications(props) {
    return <Can action="verification" subject="TagModeration" passThrough>
        {can => !can ? <ErrorUnauthorized {...props}/> : <TagModerationVerifications {...props}/>}
    </Can>;
}

function VerificationPhoto(props) {
    return <Can action="verification" subject="TagModeration" passThrough>
        {can => !can ? <ErrorUnauthorized {...props}/> : <TagModerationVerificationCategory {...props}/>}
    </Can>;
}

function VerificationVideo(props) {
    return <Can action="verification" subject="TagModeration" passThrough>
        {can => !can ? <ErrorUnauthorized {...props}/> : <TagModerationVerificationVideoCategory {...props}/>}
    </Can>;
}

function TagModeration(props) {
    return <Can action="qualification" subject="TagModeration" passThrough>
        {can => can ? <RedirecToQualificationPage {...props} /> : <AskForAuthorization {...props}/>}
    </Can>;
}

const TagModerations = ({match}) => {
    return (
        <Switch>
            <Route exact path={`${match.url}`} component={TagModeration}/>
            <Route path={`${match.url}/verifications`} component={Verifications} />
            <Route path={`${match.url}/verifications-photo/:categoryId`} component={VerificationPhoto} />
            <Route path={`${match.url}/verifications-video/:categoryId`} component={VerificationVideo} />
            <Route exact path={`${match.url}/qualifications`} component={Qualifications} />
            <Route path={`${match.url}/qualifications-photo/:categoryId`} component={QualificationPhoto} />
            <Route path={`${match.url}/qualifications-video/:categoryId`} component={QualificationVideo} />
        </Switch>
    )
}

export default withRouter(TagModerations);